export class TemplateOverrides {
    OverrideSubject: string;
    OverrideMessage: string;
    OverrideFrom: string;
    OverrideFromName: string;
}
